import { render } from "./TrashBtn.vue?vue&type=template&id=5d76e6f6&ts=true"
import script from "./TrashBtn.vue?vue&type=script&lang=ts"
export * from "./TrashBtn.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__